import React from "react";
import { MapPin, Navigation2, Star, ExternalLink, Clock } from "lucide-react";
import { Badge } from "./ui/badge";
import { siteInfo } from "../data/mock";

const GoogleMap = () => {
  const query = encodeURIComponent(`${siteInfo.name} ${siteInfo.address}`);
  const embedUrl = `https://www.google.com/maps?q=${query}&output=embed&hl=it&z=14`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${query}`;
  const gmbSearchUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-12">
          <Badge className="bg-brand-light text-brand hover:bg-brand-light mb-4 border-0">Google Business</Badge>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-dark mb-4 leading-tight">
            Trovaci su <span className="italic text-brand">Google Maps</span>
          </h2>
          <p className="text-lg text-brand-dark/70">
            Visita la nostra sede a Vibo Valentia oppure guarda recensioni, foto e orari sulla scheda Google.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Info card */}
          <div className="lg:col-span-1 bg-brand text-white rounded-3xl p-8 flex flex-col justify-between relative overflow-hidden">
            <div className="absolute inset-0 bg-dots-pattern opacity-20"></div>
            <div className="absolute -top-16 -right-16 w-52 h-52 bg-emerald-500/20 rounded-full blur-3xl"></div>

            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center mb-5">
                <MapPin className="w-7 h-7" />
              </div>
              <h3 className="font-display text-2xl font-bold mb-3">{siteInfo.name}</h3>
              <p className="text-emerald-100/90 text-sm leading-relaxed mb-6">{siteInfo.address}</p>

              {/* Reviews mock preview */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6">
                <div className="flex items-center gap-2 mb-1">
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <span className="font-bold text-lg">4.9</span>
                </div>
                <p className="text-xs text-emerald-100/80">Basato su 127 recensioni Google verificate</p>
              </div>

              <div className="flex items-center gap-2 text-sm text-emerald-100/90 mb-1">
                <Clock className="w-4 h-4" />
                <span>Lun–Ven: 09:00 – 18:00</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-emerald-100/70">
                <Clock className="w-4 h-4" />
                <span>Sab–Dom: chiuso</span>
              </div>
            </div>

            <div className="relative mt-8 space-y-2">
              <a
                href={directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 bg-white text-brand hover:bg-emerald-50 rounded-full h-11 font-semibold text-sm transition-colors"
              >
                <Navigation2 className="w-4 h-4" /> Ottieni indicazioni
              </a>
              <a
                href={gmbSearchUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full h-11 font-semibold text-sm transition-colors border border-white/20"
              >
                Apri su Google <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>

          {/* Map iframe */}
          <div className="lg:col-span-2 rounded-3xl overflow-hidden border border-emerald-100 shadow-lg bg-emerald-50 min-h-[420px]">
            <iframe
              title="Sede Associazione Progetto Futuro"
              src={embedUrl}
              width="100%"
              height="100%"
              style={{ minHeight: "420px", border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleMap;
